import i18n from '@/langs/i18n.js';

export default [
  {
    text: i18n.t('action.new'),
    value: 'NEW'
  },
  {
    text: i18n.t('action.unfinishedForm'),
    value: 'UNFINISHED_FORM'
  },
  {
    text: i18n.t('dashboard.waitOffers'),
    value: 'WAITING_FOR_OFFER'
  },
  {
    text: i18n.t('action.sent'),
    value: 'SENT'
  },
  {
    text: i18n.t('action.cancelled'),
    value: 'CANCELLED'
  },
  {
    text: i18n.t('action.completed'),
    value: 'REALIZED'
  }
]
